import React, { useEffect, useState } from "react";
import "./index.scss"
import { Button } from "antd";
import { Switch, Route, Redirect, useHistory, useRouteMatch, useLocation } from "react-router-dom"
import { ReactComponent as SearchIcon } from "../../../assets/svg/plus_btn.svg";
import { FunctionContainer } from "./functionContainer";
import { FunctionPreview } from "./functionPreview";
import CreateFunction from "./createFunction";
import { Http } from "../../../helpers/axois";
import { useDispatch, useSelector } from "react-redux";
import { logger } from "../../../constant/winston";
import { useToast } from "../../../helpers/commonFunction";
import { ReactComponent as LeftIcon } from "../../../assets/svg/layer-left.svg";
import { setFunctionData } from "../../../stateManager/store/marketplaceFunction/actions";
import { Spinner } from "../../../helpers/commonUi/Spinner";
import { SaveFunction } from './SaveFunction'
import { EditFunction } from './EditFunction'
import { CreateMarketplaceFn } from "../../../helpers/RxServices"
import NoData from "../../apps/NoData";
import { ReactComponent as WarningIcon } from '../../../assets/svg/warningIcon.svg'
import { AppState } from "../../../stateManager/store";
export const Functions: React.FC<any> = () => {
  const history: any = useHistory();
  const location: any = useLocation();
  const match: any = useRouteMatch();
  const [selectedTab, setSelectedTab] = useState("functions")
  const pathname = location.pathname;
  const hideTabs = pathname.endsWith("createFunction") || pathname.includes("functionPreview") || pathname.includes("edit");
  const showTabs = pathname.endsWith("createFunction") || pathname.includes("edit");
  const orgId = useSelector((state: any) => state.org.selectedOrg.id);
  const functionData = useSelector((state: any) => state.marketplaceFunction.functionData);
  const selectedUserId = useSelector((state: any) => state.user.data.user.id);
  const [saveFnVisibility, setSaveFnVisbility] = useState(false);
  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
  const { selectedOrg } = useSelector((state: AppState) => state.org)
  const loggedInUserId = useSelector((state: any) => {
      return state.user.data.user.id
  })
  var canViewFunctions =( orgPermissions.includes('marketplace.PublishFunc') && orgPermissions.includes('org.View'))||  loggedInUserId==selectedOrg?.owner;
  const [createFnData, setCreateFnData] = useState<any>({
    metadata: {
      name: ''
    }
  });
  const { SuccessToast, ErrorToast } = useToast();
  const dispatch = useDispatch();
  const tabs = [
    { name: "Functions", path: "functions" },
    { name: "My Functions", path: "myFunctions" },
    { name: "Installed Functions", path: "installedFunctions" },
  ];

  const handleRouteNavigation = (path: string) => {
    let pushPath = match.url;

    if (path !== "functions") {
      pushPath += "/" + path;
    }

    setSelectedTab(pushPath.split("/").at(-1))
    history.push(pushPath);
  }

  const deleteproduct = (id: string) => {
    Http.delete(`/orgs/${orgId}/marketplaceFunctions/${id}`).subscribe((res) => {
      SuccessToast("successfully deleted")
      const filteredFuctions = functionData.filter((func: any) => {
        return func.id !== id;
      })
      dispatch(setFunctionData(filteredFuctions))
    }, (e) => {
      logger.error(e)
      ErrorToast(e.message)
    });
  }

  const handleFunctionStatus = (functionId: string, status: boolean) => {
    const updatedFunctions = functionData.map((func: any) =>
    func.id === functionId ? { ...func, is_installed: status } : func
    );
    dispatch(setFunctionData(updatedFunctions));
  }
  
  const handleGoback = () => {
    history.goBack()
    setCreateFnData({ metadata: { id: '' } })
  }

  useEffect(() => {
    if(!canViewFunctions){
      return
    }
    const endPoint = `/orgs/${orgId}/marketplaceFunctions`;
    if (!pathname.includes("/functionPreview")) {
      Http.get(endPoint).subscribe((res: any) => {
        if (res) {
          dispatch(setFunctionData(res.data))
        }
      }, (e) => {
        if (e === "Forbidden") {
          canViewFunctions = false
        }
        logger.error(e);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const subscription = CreateMarketplaceFn.getMessage().subscribe(
      (res: any) => {
        if (res.message === 'sendContext') {
          setCreateFnData(res.data)
          setSaveFnVisbility(true)
        }
        if(res.message === 'sendMetadata') {
          setCreateFnData(res.data)
        }
      }
    )
    return () => {
      subscription.unsubscribe()
    }
  }, [])


  if (!functionData) {
    return <Spinner/>
  }

  return (
    <React.Fragment>
      {canViewFunctions ? <>{showTabs &&
        <div className="function">
          <div className="function-leftIcon">
            <LeftIcon onClick={handleGoback} />
            <div className="function-name">{createFnData.metadata.name ? createFnData.metadata.name : "CreateFunction"}</div>
          </div>
          <div className="function-tabs">
          <Button
            onClick={() => {
              CreateMarketplaceFn.sendMessage({
                message: 'requestContext'
              })
            }}
            type="primary"
            className="publish-btn"
          >
            {createFnData.metadata.name ? "Update" : "Publish"}
          </Button>
          {
            saveFnVisibility && (
              <SaveFunction visible={saveFnVisibility} setVisible={setSaveFnVisbility} data={createFnData}/>
            )
          }
          </div>
        </div>
      }
      <div className="widgets">
        <div style={{ height: "calc(100vh - 100px)" }}>

          {!hideTabs && <div className="header">
            <div className="left tabs">
              {tabs.map((tab: any) => (
                <p
                  data-test-id={`${tab.name}`}
                  key={tab.path}
                  className={`tab ${selectedTab === tab.path ? "active" : ""}`}
                  onClick={() => handleRouteNavigation(tab.path)}
                >
                  {tab.name}
                </p>
              ))}
            </div>
            <div className="right">
              <SearchIcon
                width="28px"
                height="28px"
                onClick={() => history.push("/marketplace/functions/createFunction")}
              />
            </div>
          </div>}
          <Switch>
            <Route path={`${match.url}/functionPreview/:functionId`}>
              <FunctionPreview />
            </Route>

            <Route path={`${match.url}/myFunctions`}>
              <FunctionContainer
                functionData={functionData.filter((el: any) => el.created_by.id === selectedUserId)}
                setSelectedTab={setSelectedTab}
                deleteproduct={deleteproduct}
                handleFunctionStatus={handleFunctionStatus}
              />
            </Route>

            <Route path={`${match.url}/installedFunctions`}>
              <FunctionContainer
                deleteproduct={deleteproduct}
                functionData={functionData.filter((el: any) => el.is_installed)}
                setSelectedTab={setSelectedTab}
                handleFunctionStatus={handleFunctionStatus}
              />
            </Route>

            <Route path={`${match.url}/edit/:functionId`}>
              <EditFunction />
            </Route>

            <Route path={`${match.url}/createFunction`}>
              <CreateFunction />
            </Route>

            <Route exact path={match.url}>
              <FunctionContainer
                deleteproduct={deleteproduct}
                functionData={functionData}
                setSelectedTab={setSelectedTab}
                handleFunctionStatus={handleFunctionStatus}
              />
            </Route>

            <Route component={() => <Redirect to="/404" />} />
          </Switch>
        </div>
        </div></> : <NoData
        svg={WarningIcon}
        header='Not Authorized'
        content='Please request owner of this organization to provide access'
        noButton={true}
      />}
    </React.Fragment>
  );
}

export default Functions;
